import React from 'react';
import CarrierAccountsPanel from '@/components/CarrierAccountsPanel';

export default function OperatorCarrierAccounts() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-5xl mx-auto p-6">
        <div className="mb-2 text-xs text-neutral-500">3PL 관리자 › 택배 계약</div>
        <CarrierAccountsPanel scope="operator" testidPrefix="operator" />
      </div>
    </div>
  );
}
